import { setBodyScrollLock, getScrollPosition } from '../utils/dom';
import { elements, state, FIXED_HEIGHT_DELAY } from './config';
import { hideNavbarDropdown } from './dropdown';

function handleOutsideClick(): void {
    closeMobileMenu();
}

// Anchor the mobile menu just below the navbar bar. The bar can be pushed down
// by a top banner (.site-banner--top) of variable height, so measure the
// navbar's actual bottom edge; CSS falls back to 72px when this isn't set.
// Re-run on resize and when a banner is dismissed so the menu follows the bar.
function updateMobileTop(): void {
    if (!elements.navbar) {
        return;
    }

    const navbarBottom = Math.max(0, elements.navbar.getBoundingClientRect().bottom);
    elements.body.style.setProperty('--mp-mobile-top', `${navbarBottom}px`);
}

export function openMobileMenu(): void {
    state.scrollTop = getScrollPosition();
    state.isMobileMenuOpen = true;

    setBodyScrollLock(true);
    elements.body.classList.add('mp-navbar-mobile-visible');
    elements.body.setAttribute('aria-expanded', 'true');

    updateMobileTop();
    window.addEventListener('resize', updateMobileTop);

    setTimeout(() => {
        if (elements.mpWrapper) {
            elements.mpWrapper.addEventListener('click', handleOutsideClick);
            elements.mpWrapper.addEventListener('touchstart', handleOutsideClick, { passive: true });
        }
    }, 0);

    setTimeout(() => {
        elements.body.classList.add('fixed-height');
    }, FIXED_HEIGHT_DELAY);
}

export function closeMobileMenu(): void {
    state.isMobileMenuOpen = false;

    elements.body.classList.remove('mp-navbar-mobile-visible', 'fixed-height');
    elements.body.setAttribute('aria-expanded', 'false');
    elements.body.style.removeProperty('--mp-mobile-top');
    window.removeEventListener('resize', updateMobileTop);
    window.scrollTo(0, state.scrollTop);

    if (elements.mpWrapper) {
        elements.mpWrapper.removeEventListener('click', handleOutsideClick);
        elements.mpWrapper.removeEventListener('touchstart', handleOutsideClick);
    }

    if (elements.mobileSidebar) {
        elements.mobileSidebar.classList.remove('opened-submenu');
    }

    setBodyScrollLock(false);
    hideNavbarDropdown();
}

export function toggleMobileMenu(): void {
    if (state.isMobileMenuOpen) {
        closeMobileMenu();
    } else {
        openMobileMenu();
    }
}